/**
 * Authentication Service Module
 * Provides functionality for user authentication, session management,
 * and user-related operations using Parse backend.
 */

import Parse from './parse.service'

/**
 * Creates an Access Control List (ACL) for the current user
 * @returns {Parse.ACL} ACL object configured for the current user with public read access
 */
export const userACL = () => {
    const user = fetchUser();
    const acl = new Parse.ACL(user);
    console.log("acl", acl);
    acl.setPublicReadAccess(true);
    return acl;
}

/**
 * Retrieves the currently logged in user
 * @returns {Parse.User|null} Current user object or null if no user is logged in
 */
export const fetchUser = () => {
    return Parse.User.current()
}

/**
 * Logs out the current user
 * @returns {Promise} Promise that resolves when logout is complete
 */
export function logout() {
    return Parse.User.logOut()
}

/**
 * Updates the email address for the current user
 * @param {string} email - New email address to set
 * @returns {Promise<Parse.User|Error>} Updated user object or error if update fails
 */
export const updateEmail = async (email) => {
    try {
        const user = fetchUser();
        user.set('email', email || undefined);
        await user.save();
        return user;
    } catch (err) {
        throw new Error(err);
    }
}

/**
 * Sends a verification email to the specified email address
 * @param {string} email - Email address to verify
 * @returns {Promise<Parse.User|Error>} User object if successful, error if failed
 */
export const sendVerificationEmail = async (email) => {
    try {
        const user = fetchUser();
        user.set('email', email);
        var result = await user.save();
        return result;
    } catch (err) {
        return err;
    }
}

/**
 * Logs in a user using a session token
 * @param {string} sessionToken - Session token to authenticate with
 * @returns {Promise<Object>} Object containing status and response
 */
export const loginUsingSession = async (sessionToken) => {
    try {
        const res = await Parse.User.become(sessionToken)
        return { status: "success", response: res };
    } catch (error) {
        return { status: "error", response: error };
    }
}
